import fondo from "../assets/fondos/LogoPiedecuestana.png";

export default function Layout({ children }) {
  return (
    <div
      className="h-screen w-full flex items-center justify-center bg-cover bg-center relative"
      style={{ backgroundImage: `url(${fondo})` }}
    >
      {/* Overlay global */}
      <div className="absolute inset-0 bg-white/80"></div>

      {/* Contenido de cada módulo */}
      <div className="relative w-full h-full flex items-center justify-center">
        {children}
      </div>
    </div>
  );
}
